import { SparkComponent } from "ags/components/ags-spark-component";
import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { RandomBoolean, RandomRangeInt } from "appworks/utils/math/random";

export class ThemeSparkComponent extends SparkComponent {
    protected createSparkSprite() {
        // do nothing
    }

    protected createTrailEmitter() {
        this.config.tweenDuration = 800;
        this.config.emitterShutdownDelay = 0;
        super.createTrailEmitter(["coinSpark"]);
    }

    protected getSparkPath(): DualPosition[] {
        const path = super.getSparkPath();

        const middlePos = new DualPosition();
        middlePos.landscape.x = (path[0].landscape.x + path[1].landscape.x) / 2;
        middlePos.portrait.x = (path[0].portrait.x + path[1].portrait.x) / 2;
        middlePos.landscape.y = path[1].landscape.y - RandomRangeInt(400, 800);
        middlePos.portrait.y = path[1].portrait.y - RandomRangeInt(400, 800);

        middlePos.portrait.x += RandomRangeInt(250, 500) * (RandomBoolean() ? -1 : 1);

        path.splice(1, 0, middlePos);

        return path;
    }
}
